module.exports = __webpack_public_path__ + "public/img/xiaofei.eed34fc8.png";